import { UseMutationOptions, useQueryClient } from '@tanstack/react-query';

import MutationKeys from 'hooks/mutations/keys';
import QueryKeys from 'hooks/queries/keys';
import useMutation from 'hooks/useMutation';
import { ApiMethods, CuredApiPaths } from 'models/enums';

import type { BulkReAssignRoleApiResponse, BulkReAssignRoleInput } from 'domains/accessCentre/types';

export type { BulkReAssignRoleApiResponse, BulkReAssignRoleInput } from 'domains/accessCentre/types';

/** POST /users/bulk-assign-role — assign the same role to multiple users */
const useBulkReAssignRole = (
    mutateOptions?: UseMutationOptions<BulkReAssignRoleApiResponse, Error, BulkReAssignRoleInput>
) => {
    const queryClient = useQueryClient();
    const path = CuredApiPaths.ACCESS_CENTRE_USERS_BULK_ASSIGN_ROLE;

    const { onSuccess: onSuccessOption, ...restMutateOptions } = mutateOptions ?? {};

    return useMutation<BulkReAssignRoleInput, BulkReAssignRoleApiResponse>(
        MutationKeys.BULK_REASSIGN_USER_ROLE,
        path,
        {
            onSuccess: (data, variables, context) => {
                queryClient.invalidateQueries(['access-centre', 'users']);
                data.ids.forEach((userId) => {
                    queryClient.invalidateQueries(QueryKeys.ACCESS_CENTRE_USER_ID(userId));
                });
                onSuccessOption?.(data, variables, context);
            },
            ...restMutateOptions,
        },
        ApiMethods.POST
    );
};

export default useBulkReAssignRole;
